import _possibleConstructorReturn from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { SessionData } from './sessionData';
import { LOCALSTORAGE_SESSION_KEY } from './constants';
import { NoSessionDataError } from '@stacks/common';
export var SessionDataStore =
/*#__PURE__*/
function () {
  function SessionDataStore(sessionOptions) {
    _classCallCheck(this, SessionDataStore);

    if (sessionOptions) {
      var newSessionData = new SessionData(sessionOptions);
      this.setSessionData(newSessionData);
    }
  }

  _createClass(SessionDataStore, [{
    key: "getSessionData",
    value: function getSessionData() {
      throw new Error('Abstract class');
    }
  }, {
    key: "setSessionData",
    value: function setSessionData(_session) {
      throw new Error('Abstract class');
    }
  }, {
    key: "deleteSessionData",
    value: function deleteSessionData() {
      throw new Error('Abstract class');
    }
  }]);

  return SessionDataStore;
}();
export var InstanceDataStore =
/*#__PURE__*/
function (_SessionDataStore) {
  _inherits(InstanceDataStore, _SessionDataStore);

  function InstanceDataStore(sessionOptions) {
    var _this;

    _classCallCheck(this, InstanceDataStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InstanceDataStore).call(this, sessionOptions));

    if (!_this.sessionData) {
      _this.setSessionData(new SessionData({}));
    }

    return _this;
  }

  _createClass(InstanceDataStore, [{
    key: "getSessionData",
    value: function getSessionData() {
      if (!this.sessionData) {
        throw new NoSessionDataError('No session data was found.');
      }

      return this.sessionData;
    }
  }, {
    key: "setSessionData",
    value: function setSessionData(session) {
      this.sessionData = session;
      return true;
    }
  }, {
    key: "deleteSessionData",
    value: function deleteSessionData() {
      this.setSessionData(new SessionData({}));
      return true;
    }
  }]);

  return InstanceDataStore;
}(SessionDataStore);
export var LocalStorageStore =
/*#__PURE__*/
function (_SessionDataStore2) {
  _inherits(LocalStorageStore, _SessionDataStore2);

  function LocalStorageStore(sessionOptions) {
    var _this2;

    _classCallCheck(this, LocalStorageStore);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(LocalStorageStore).call(this, sessionOptions));

    if (sessionOptions && sessionOptions.storeOptions && sessionOptions.storeOptions.localStorageKey && typeof sessionOptions.storeOptions.localStorageKey === 'string') {
      _this2.key = sessionOptions.storeOptions.localStorageKey;
    } else {
      _this2.key = LOCALSTORAGE_SESSION_KEY;
    }

    var data = localStorage.getItem(_this2.key);

    if (!data) {
      var sessionData = new SessionData({});

      _this2.setSessionData(sessionData);
    }

    return _this2;
  }

  _createClass(LocalStorageStore, [{
    key: "getSessionData",
    value: function getSessionData() {
      var data = localStorage.getItem(this.key);

      if (!data) {
        throw new NoSessionDataError('No session data was found in localStorage');
      }

      var dataJSON = JSON.parse(data);
      return SessionData.fromJSON(dataJSON);
    }
  }, {
    key: "setSessionData",
    value: function setSessionData(session) {
      localStorage.setItem(this.key, session.toString());
      return true;
    }
  }, {
    key: "deleteSessionData",
    value: function deleteSessionData() {
      localStorage.removeItem(this.key);
      this.setSessionData(new SessionData({}));
      return true;
    }
  }]);

  return LocalStorageStore;
}(SessionDataStore);